"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPill = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var IconButton_1 = __importDefault(require("@atg/icf-react-components/components/IconButton"));
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var useFilterPillStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    filterPillItem: {
        backgroundColor: theme.colors.primary,
        borderRadius: "2px",
        marginInlineEnd: theme.spacing.base / 2,
        marginBottom: "4px",
        display: "inline-block",
        "& .root": {
            // eslint-disable-next-line @atg/css-rtl-support
            padding: "0 8px 0 0",
        },
        "& .svg": {
            fill: "rgba(0, 0, 0, 0.3)",
        },
    },
    pillLabel: {
        fontSize: "14px",
        fontStyle: "normal",
        fontStretch: "normal",
        letterSpacing: "0.15px",
        color: theme.colors.textOnDark,
        margin: "8px",
        display: "inline-block",
        fontWeight: "inherit",
    },
}); });
var FilterPill = function (_a) {
    var emitTrackingEvent = _a.emitTrackingEvent, label = _a.label, onFilterClose = _a.onFilterClose, translate = _a.translate;
    var classes = useFilterPillStyles();
    return (react_1.default.createElement("div", { className: classes.filterPillItem, "data-ta-locator": "filterPill" },
        react_1.default.createElement("div", { className: classes.pillLabel }, translate(label)),
        react_1.default.createElement(IconButton_1.default, { name: "cancel", onClick: function () {
                onFilterClose();
                emitTrackingEvent("icfClick", "filterPillClose", "label=".concat(label));
            }, "data-ta-locator": "pillCloseButton", type: "default", size: "small", overrides: {
                root: "root",
                svgIcon: "svg",
            } })));
};
exports.FilterPill = FilterPill;
exports.FilterPill.displayName = "FilterPill";
//# sourceMappingURL=FilterPill.js.map